import PaymentsForInvoiceDatagrid from 'src/components/DatagridEntity/PaymentsForInvoiceDatagrid';

const PaymentsInvoicePage = () => (<PaymentsForInvoiceDatagrid />);
export default PaymentsInvoicePage;
